import Axios from 'axios'
import React from 'react'
import { toast } from 'react-toastify'
import config from 'src/config'
import { COLORS } from 'src/styles/theme'

export const LiveCheckInButton = ({ snapshot, loading, error }) => {
  if (!loading && !error && snapshot && snapshot.val() && snapshot.val().sessionId) {
    const sessionId = snapshot.val().sessionId

    const handleCheckIn = () => {
      Axios.post(
        `${config.apiUrl}/api/v1/hall_sessions/${sessionId}/check_in`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('jwt_token')}`,
          },
        }
      )
        .then((result) => {
          if (result.data.success) {
            toast('You Have Redeemed Your Lunch Voucher!')
          } else {
            toast(result.data.error)
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.error)
          console.error(error)
        })
    }

    return (
      <div className="attendance">
        <button type="button" id="check-in-btn" className="action-button" onClick={handleCheckIn}>
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="M0,0H24V24H0Z" fill="none" />
            <path
              d="M19,3H14.82A2.988,2.988,0,0,0,9.18,3H5A2.006,2.006,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3ZM9.29,16.29,6.7,13.7a1,1,0,0,1,1.41-1.41L10,14.17l5.88-5.88A1,1,0,1,1,17.29,9.7L10.7,16.29a1,1,0,0,1-1.41,0Z"
              fill={COLORS.hotButtonText}
            />
          </svg>
          CHECK-IN
        </button>
      </div>
    )
  } else {
    return null
  }
}
